// extracted by mini-css-extract-plugin
export default {"details":"MovieDetails_details__xKKzZ","pitch":"MovieDetails_pitch__ozVlz","form":"MovieDetails_form__GaGOG","hadopi":"MovieDetails_hadopi__C558h"};